export const NOTE_FIELD_NAMES = {
  ID: 'id',
  USER: 'user',
  TASKS: 'tasks',
  TAGS: 'tags',
  TEXT: 'text',
  IS_PRIVATE: 'is_private',
};
